// extracted by mini-css-extract-plugin
module.exports = {"avatarThumb":"Avatar_avatarThumb__17J9D","avatar":"Avatar_avatar__3iNIG"};